const menu = [
  {
    heading: "UPSLSA-AI Chatbot",
  },
  // {
  //   icon: "bag",
  //   text: "E-Commerce Panel",
  //   link: "/ecommerce/index",
  //   panel: true,
  //   newTab: true,
  //   subPanel: [
  //     {
  //       icon: "dashboard-fill",
  //       text: "Dashboard",
  //       link: "/ecommerce/index",
  //     },
  //     {
  //       icon: "bag-fill",
  //       text: "Orders",
  //       link: "/ecommerce/orders",
  //     },
  //     {
  //       icon: "package-fill",
  //       text: "Products",
  //       link: "/ecommerce/products",
  //     },
  //     {
  //       icon: "users-fill",
  //       text: "Customers",
  //       link: "/ecommerce/customer",
  //     },
  //     {
  //       icon: "chat-fill",
  //       text: "Support",
  //       link: "/ecommerce/support",
  //     },
  //     {
  //       icon: "opt-alt-fill",
  //       text: "Settings",
  //       link: "/ecommerce/settings",
  //     },
  //     {
  //       icon: "server-fill",
  //       text: "Integration",
  //       link: "/ecommerce/integration",
  //     },
  //   ],
  // },
  // {
  //   heading: "Dashboards",
  // },

  // {
  //   icon: "cart-fill",
  //   text: "Default",
  //   link: "/",
  // },
  {
    icon: "dashboard-fill",
    text: "Dashboard",
    link: "/dashboard",
  },
  {
    icon: "account-setting-fill",
    text: "Admin User",
    link: "/admin-user",
    requiredPermission: "users.view",
  },
  {
    icon: "users-fill",
    text: "Registered User",
    link: "/user",
    requiredPermission: "users.view",
  },
  {
    icon: "map-pin-fill",
    text: "User origins report",
    link: "/report/user-origins",
    requiredPermission: "users.view",
  },

  {
    icon: "question",
    text: "Question",
    //  link: "/question",
    subMenu: [
      {
        icon: "question",
        text: "Questions",
        link: "/question/approved-questions",
        requiredPermission: "qa.view",
      },
      {
        icon: "question",
        text: "Pending Questions",
        link: "/question/requested-questions",
        requiredPermission: "qa.view",
      },
      {
        icon: "question",
        text: "UnAnswered Questions",
        link: "/unanswered-questions",
        requiredPermission: "qa.view",
      },
      {
        icon: "question",
        text: "Rejected Questions",
        link: "/question/rejected-questions",
        requiredPermission: "qa.view",
      },
    ],
  },
  // {
  //   icon: "activity-round-fill",
  //   text: "Sales",
  //   link: "/sales",
  // },
  // {
  //   icon: "growth-fill",
  //   text: "Analytics",
  //   link: "/analytics",
  // },
  // {
  //   heading: "Pre-built Pages",
  // },
  // {
  //   icon: "tile-thumb-fill",
  //   text: "Projects",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "Project Cards",
  //       link: "/project-card",
  //     },
  //     {
  //       text: "Project List",
  //       link: "/project-list",
  //     },
  //   ],
  // },
  // {
  //   icon: "users-fill",
  //   text: "User Manage",
  //   active: false,
  //   subMenu: [
  //     {
  //       text: "User List - Default",
  //       link: "/user-list-default",
  //     },
  //     {
  //       text: "User List - Regular",
  //       link: "/user-list-regular",
  //     },
  //     {
  //       text: "User List - Compact",
  //       link: "/user-list-compact",
  //     },
  //     {
  //       text: "User Details - Regular",
  //       link: "/user-details-regular/1",
  //     },
  //     {
  //       text: "User Profile - Regular",
  //       link: "/user-profile-regular",
  //     },
  //     {
  //       text: "User Contact - Card",
  //       link: "/user-contact-card",
  //     },
  //   ],
  // },

 
];
export default menu;
